import { configureStore } from '@reduxjs/toolkit';
import uiReducer from './slices/uiSlice';
import filtersReducer from './slices/filtersSlice';
import userReducer from './slices/userSlice';

export const store = configureStore({
	reducer: {
		ui: uiReducer,
		filters: filtersReducer,
		user: userReducer,
	},
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: {
				ignoredActions: ['persist/PERSIST'],
			},
		}),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;